import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { GeneratedFile } from '@cli-types/core-engine/schema.js'
import { createGeneratedFile } from '@cli-utils/files.js'
import { resolveProjectPaths } from '@next-adapter/config/paths/resolve-project-paths.js'
import { namespaceGeneratedFiles } from '@next-adapter/generators/namespace-output/namespace-generated-files.js'
import { listExtractNames } from './list-extract-names.js'
import { listNamespacedExtracts } from './list-namespaced-extracts.js'
import { renderDbBarrel } from './render-db-barrel.js'
import { renderNavigationBarrel } from './render-navigation-barrel.js'
import { renderWebhookEventsBarrel } from './render-webhook-events-barrel.js'

export function renderBarrelFiles(cwd: string, config: ResolvedBetterstartConfig): GeneratedFile[] {
  const paths = resolveProjectPaths(config)
  const dbExtracts = listNamespacedExtracts(cwd, paths.adminDbDir).filter(
    (extract) => !(extract.namespace === 'core' && extract.name === 'schema')
  )
  const navExtractNames = listExtractNames(cwd, paths.adminNavigationDir, new Set(['core']))
  const webhookEventExtractNames = listExtractNames(cwd, paths.adminWebhookEventsDir)

  return namespaceGeneratedFiles(
    [
      createGeneratedFile(paths.adminDbSchemaFile, renderDbBarrel(dbExtracts)),
      createGeneratedFile(
        paths.adminNavigationFile,
        renderNavigationBarrel(navExtractNames, config.frameworkConfig.next.namespace)
      ),
      createGeneratedFile(
        paths.adminWebhookEventsFile,
        renderWebhookEventsBarrel(webhookEventExtractNames, config.frameworkConfig.next.namespace)
      )
    ],
    config.frameworkConfig.next.namespace
  )
}
